import routesLimited from '@/constants/routesLimited'
import { hideUpdateRequests } from 'plugins/router/routes/global'
import type { RouteRecordRaw } from 'vue-router'
import { aliases } from '../aliases'
import { canViewPersonalAccountsNow } from '@/composables/usePersonalAccountsAccess'

const changePassword: RouteRecordRaw = {
	component: () => import('components/modules/Login/Password/ResetDialog.vue'),
	meta: {
		title: 'routeTitle.profileChangePassword',
		icon: 'fal fa-key',
	},
	name: 'changePassword',
	path: 'password/change/',
	props: (route) => ({
		reset: route.query.reset === 'true',
		routeNameOnClose: route.query.routeNameOnClose,
		email: route.query.email,
	}),
}
const createPersonUpdateRequest: RouteRecordRaw = {
	component: () =>
		import('@/components/modules/Profile/UpdateRequest/PersonCreateEdit.vue'),
	meta: {
		title: 'routeTitle.profileUpdateRequest',
		icon: 'fal fa-key',
		edit: false,
		hidden: hideUpdateRequests,
	},
	name: 'createPersonDataRequest',
	path: 'personupdaterequests',
	props: true,
}
const avatarUpload: RouteRecordRaw = {
	name: 'avatarUpload',
	path: 'avatarupload',
	component: () => import('components/modules/Profile/AvatarUpload.vue'),
	meta: {
		limited: routesLimited.isAdminOrTeam,
		title: 'routeTitle.profileUploadPicture',
	},
	props: { multiple: false },
}
const myAccounts: RouteRecordRaw = {
	name: 'myAccounts',
	path: 'accounts',
	component: () => import('components/modules/Profile/MyAccounts.vue'),
	meta: {
		title: 'routeTitle.profileMyAccounts',
		icon: 'fal fa-wallet',
		auth: true,
	},
	// AAR-1494 — Direktaufruf absichern: nur Karthago/hpPsql + Rollen-Gate.
	beforeEnter: () =>
		canViewPersonalAccountsNow() ? true : { name: 'profile' },
}
const profile: RouteRecordRaw = {
	children: [
		changePassword,
		avatarUpload,
		createPersonUpdateRequest,
		myAccounts,
	],
	name: 'profile',
	path: '/profile/:id?',
	alias: aliases.user_report,
	component: () => import('components/modules/Profile/Profile.vue'),
	meta: {
		title: 'routeTitle.profileAccount',
		icon: 'fa-fw far fa-user-circle',
		auth: true,
		nav: false,
		ordering: 7,
		tour: true,
	},
}

export const profileRoutes: RouteRecordRaw[] = [
	profile,
	avatarUpload,
	createPersonUpdateRequest,
	changePassword,
	myAccounts,
]

export { profile }
